<template>
    <div>
        <v-overlay :value="loading" z-index="1000">
            <v-card
                width="350px"
                height="70px"
                color="white"
            >
            <div class="loading-content">
                <v-progress-circular
                    indeterminate
                    color="green"
                    class="mr-5"
                ></v-progress-circular>
                <span class="black--text font-weight-bold">{{ message }}</span>
            </div>
            </v-card>
        </v-overlay>
    </div>
</template>

<script>
export default {
  props: ['loading', 'message']
}
</script>

<style scoped>
.loading-content{
    text-align: center;
    padding-top: 15px;
    font-size: 1.3rem;
}
</style>
